var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLazyLoaded)?_c('winners-highlights-modal',{on:{"hook:mounted":_vm.$_lazyLoadModal_onComponentMounted}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }